import styled from "styled-components";
import "../../../styles/sass/Pages/_newDesign.scss";

export const Container = styled.div.withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	display: flex;
	align-items: center;

	border: solid 2px ${(props) => (!props.error ? "#353546" : "#D30D48")};
	color: #ffffff;
	font-size: 16px;
	width: 100%;
	height: 56px;
	border-radius: 8px;

	:focus-within {
		border: solid 2px ${(props) => (!props.error ? "#01E59B" : "#D30D48")};
		border-radius: 8px;
	}
`;
